'use strict';

/* Relevance Engine Factory: 3 things API */


angular.module('storyApp').factory('relevanceEngine', ['$http', '$q', '$location', 'trackingUtils' ,'storiesFilterService', function($http, $q, $location, trackingUtils ,storiesFilterService) {

    return {

        apiUrl: '',
        isTestApi: false,
        devEnvThreethingsApi: 'http://api.foxsports.com/v2/wpcontent?url=' + $location.absUrl(),
        hostNames: ['www.foxsports.com', 'www.prod.wp.foxsports.com', 'www.outkickthecoverage.com', 'foxsports.dev'],
        baseUrl: location.origin || location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''),

        //hardcode articleApiPath /wp-admin/admin-ajax.php for now. This path needs to be updated for security reason
        threethingQuery: '?threeThings=true',

        //set 3 things API
        setApiUrl: function(apiUrl) {

            var that = this,
                locHref =  location.href,
                hostName = location.hostname;

            that.apiUrl = apiUrl;

            // on dev environments, use 3 things API on dev
            if (that.hostNames.indexOf(hostName) === -1){
                that.apiUrl = that.devEnvThreethingsApi;
            }

            // use 3 things dummy file if url contains 'testapi=true'
            if ( locHref.indexOf('testapi=true' ) > -1 ){
                that.apiUrl = '/wp-content/themes/foxsports/assets/dist/dummy.html?id=1';
                that.isTestApi = true;
            }

        },

        getApiUrl: function() {
            return this.apiUrl;
        },
        filterDataFromStorage: function(docsData){
            var that = this;
            if(typeof window.localStorage !== 'undefined') {
                var currentStories = storiesFilterService.getCurrentStories('all',storiesFilterService.storeAllStories(docsData));
                return currentStories;
            }else{
                return docsData;
            }
        },
        getThreeThings: function(apiUrl) {

            var that = this;
            that.setApiUrl(apiUrl);

            var deferred = $q.defer();

            //don't run the filter when using test API, dummy files
            if(!that.isTestApi) {
                apiUrl = storiesFilterService.verifyApiURLStoryCount(that.getApiUrl());
            } else {
                apiUrl = that.getApiUrl();
            }


            $http({
                method: 'GET',
                url: apiUrl
            }).success(function(data) {

                var response = data.response;

                if (typeof response !== 'undefined') {

                    // Creating and triggering the Impression event to Relevancy Engine
                    trackingUtils.sendThreeThingsData(data);

                    var docs = response.docs;

                    if (typeof docs !== 'undefined' && docs.length > 0) {

                        if(!that.isTestApi) {
                            data = that.filterDataFromStorage(docs).slice(0, 3);
                        } else {
                            data = docs.slice(0, 3);
                        }

                        data = that.updateApiResponseUrls(data);

                        deferred.resolve(data);

                    }
                }

            }).error(function(msg) {
                deferred.reject(msg);
            });

            return deferred.promise;

        },
        updateApiResponseUrls: function(data){

            var that = this;

            for(var i=0, l=data.length; i<l; i++){

                if(data[i].url !== undefined) {

                    var url = data[i].url;
                    var int = url.indexOf('.com');

                    //remove host name for all urls. It won't work in angularJS app if we use absolute urls.
                    if ( int > -1 ) {
                        data[i].url = url.substring(int + 4);
                    }

                    data[i].articleUrl =  data[i].url + that.threethingQuery;
                }
            }

            return data;
        }

    }

}]);



// WEBPACK FOOTER //
// ./assets/components/threethings/factories/relevanceEngine.js